(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-outfits"] && !Shopify.designMode) return;
  try {
    
if (!window.customElements.get('before-after-outfits')) {
  class BeforeAfterOutfits extends HTMLElement {
    connectedCallback() {
      this.tablist = this.querySelector('[role="tablist"]');
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      this.onTabClick = this.onTabClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);

      this.tablist?.addEventListener('click', this.onTabClick);
      this.tablist?.addEventListener('keydown', this.onKeydown);
      this.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      this.tablist?.removeEventListener('click', this.onTabClick);
      this.tablist?.removeEventListener('keydown', this.onKeydown);
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    onTabClick(event) {
      if (event.target.closest('a')) return;
      const item = event.target.closest('.before-after-outfits__item');
      const tab = item?.querySelector('[role="tab"]');
      if (!tab || !this.tabs.includes(tab)) return;
      this.select(this.tabs.indexOf(tab));
    }

    onKeydown(event) {
      const tab = event.target.closest('[role="tab"]');
      const current = this.tabs.indexOf(tab);
      if (current < 0) return;

      let next = current;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        next = (current + 1) % this.tabs.length;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        next = (current - 1 + this.tabs.length) % this.tabs.length;
      } else if (event.key === 'Home') {
        next = 0;
      } else if (event.key === 'End') {
        next = this.tabs.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      this.select(next);
      this.tabs[next].focus();
    }

    onBlockSelect(event) {
      const item = event.target.closest('[data-outfit-id]');
      if (!item || !this.contains(item)) return;
      const tab = item.querySelector('[role="tab"]');
      if (tab) this.select(this.tabs.indexOf(tab));
    }

    select(index) {
      if (index < 0 || index === this.selectedIndex) return;

      this.tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
      });

      this.panels.forEach((panel, i) => {
        panel.hidden = i !== index;
      });

      const comparison = this.panels[index]?.querySelector('before-after');
      if (comparison) {
        comparison.style.setProperty('--before-after-cursor-position', 'var(--before-after-initial-cursor-position)');
      }

      this.tabs[index]?.closest('.before-after-outfits__item')?.scrollIntoView({
        inline: 'nearest',
        block: 'nearest',
        behavior: 'smooth'
      });
    }

    get selectedIndex() {
      return this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
    }
  }

  window.customElements.define('before-after-outfits', BeforeAfterOutfits);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(() => {
  const closeAllLists = (except) => {
    document.querySelectorAll('.cart-upsell__option').forEach((group) => {
      if (except && group === except) return;
      const list = group.querySelector('.cart-upsell__list');
      const trigger = group.querySelector('.cart-upsell__trigger');
      if (list) list.hidden = true;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  };

  const syncVariant = (root) => {
    if (!root) return;
    const form = root.querySelector('form');
    const idInput = form?.querySelector('[name="id"]');
    const image = root.querySelector('.line-item__media img');
    const link = root.querySelector('[data-cart-upsell-link]');
    const price = root.querySelector('[data-cart-upsell-price]');
    const submitButton = root.querySelector('button[type="submit"]');
    const optionGroups = Array.from(root.querySelectorAll('[data-cart-upsell-option]'));
    let variants = [];
    try {
      variants = JSON.parse(root.querySelector('[data-cart-upsell-variants]')?.textContent || '[]');
    } catch (error) {
      variants = [];
    }

    const selected = optionGroups.map((group) => group.dataset.selected || '');
    const variant = variants.find((item) => selected.every((value, index) => item.options[index] === value));
    if (!variant) {
      if (submitButton) submitButton.disabled = true;
      return;
    }

    if (idInput) idInput.value = String(variant.id);
    if (submitButton) submitButton.disabled = !variant.available;
    if (price && variant.price) price.textContent = variant.price;
    if (image && variant.image) {
      image.src = variant.image;
      image.removeAttribute('srcset');
    }
    if (link && variant.url) link.setAttribute('href', variant.url);
  };

  window.__cartUpsellOnClick = (event) => {
    const trigger = event.target.closest('.cart-upsell__trigger');
    const choice = event.target.closest('.cart-upsell__choice');

    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      const group = trigger.closest('.cart-upsell__option');
      const list = group?.querySelector('.cart-upsell__list');
      if (!group || !list) return;
      const willOpen = list.hidden;
      closeAllLists();
      list.hidden = !willOpen;
      trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      return;
    }

    if (choice) {
      event.preventDefault();
      event.stopPropagation();
      const group = choice.closest('[data-cart-upsell-option]');
      const root = choice.closest('cart-upsell');
      if (!group) return;
      group.dataset.selected = choice.dataset.value || '';
      const label = group.querySelector('[data-cart-upsell-label]');
      if (label) label.textContent = choice.dataset.value || '';
      group.querySelectorAll('.cart-upsell__choice').forEach((item) => {
        item.setAttribute('aria-selected', item === choice ? 'true' : 'false');
      });
      closeAllLists();
      syncVariant(root);
      return;
    }

    if (!event.target.closest('.cart-upsell__option')) {
      closeAllLists();
    }
  };

  if (!window.__cartUpsellClickBound) {
    window.__cartUpsellClickBound = true;
    document.addEventListener('click', (event) => window.__cartUpsellOnClick(event));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAllLists();
    });
  }
})();

if (!window.customElements.get('cart-drawer-recommendations')) {
  class CartDrawerRecommendations extends HTMLElement {
    connectedCallback() {
      this.loadRecommendations();
    }

    async loadRecommendations() {
      if (this.dataset.loaded === 'true') return;
      this.dataset.loaded = 'true';

      const productIds = (this.getAttribute('products') || '')
        .split(',')
        .map((id) => id.trim())
        .filter((id, index, list) => id && list.indexOf(id) === index)
        .slice(0, 5);
      const limit = parseInt(this.getAttribute('limit') || '10', 10);
      const intent = this.getAttribute('intent') || 'related';
      const carousel = this.querySelector('.cart-drawer__cross-sell-carousel');
      const nav = this.querySelector('[data-cross-sell-nav]');

      if (!carousel || productIds.length === 0) {
        this.remove();
        return;
      }

      let cardLists = [];
      try {
        cardLists = await Promise.all(productIds.map(async (productId) => {
          const url = `${Shopify.routes.root}recommendations/products?product_id=${productId}&limit=${limit}&section_id=cart-cross-sell&intent=${intent}`;
          const response = await fetch(url);
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          return Array.from(doc.querySelectorAll('.product-cross-sell'));
        }));
      } catch (error) {
        this.remove();
        return;
      }

      const seen = new Set();
      const merged = [];
      const maxLength = Math.max(0, ...cardLists.map((list) => list.length));

      for (let index = 0; index < maxLength && merged.length < limit; index++) {
        for (const list of cardLists) {
          const card = list[index];
          if (!card) continue;

          const key = card.querySelector('a[href]')?.pathname;
          if (!key || seen.has(key)) continue;

          seen.add(key);
          merged.push(document.importNode(card, true));
          if (merged.length >= limit) break;
        }
      }

      if (merged.length === 0) {
        this.remove();
        return;
      }

      carousel.replaceChildren(...merged);
      if (nav) nav.hidden = merged.length <= 1;
      this.hidden = false;
    }
  }

  window.customElements.define('cart-drawer-recommendations', CartDrawerRecommendations);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-breadcrumb"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.shapellxCollectionBreadcrumbReady) return;

  window.shapellxCollectionBreadcrumbReady = true;

  const STORAGE_KEY = 'shapellx:collection-breadcrumb-parent';

  const readStoredHandle = () => {
    try {
      return sessionStorage.getItem(STORAGE_KEY);
    } catch (error) {
      return null;
    }
  };

  const writeStoredHandle = (handle) => {
    try {
      sessionStorage.setItem(STORAGE_KEY, handle);
    } catch (error) {}
  };

  const parseParents = (nav) => {
    const parentsEl = nav.querySelector('[data-breadcrumb-parents]');

    if (!parentsEl) return [];

    try {
      const parents = JSON.parse(parentsEl.textContent);
      return Array.isArray(parents) ? parents : [];
    } catch (error) {
      return [];
    }
  };

  const syncCollectionBreadcrumb = (root = document) => {
    root.querySelectorAll('[data-collection-breadcrumb]').forEach((nav) => {
      const isHub = nav.getAttribute('data-breadcrumb-hub') === 'true';
      const handle = nav.getAttribute('data-breadcrumb-handle');

      if (isHub && handle) {
        writeStoredHandle(handle);
        return;
      }

      const storedHandle = readStoredHandle();
      const parents = parseParents(nav);

      if (!storedHandle || parents.length === 0) return;

      const match = parents.find((parent) => parent.handle === storedHandle);

      if (!match || !match.url || !match.title) return;

      const link = nav.querySelector('[data-breadcrumb-parent-link]');

      if (!link) return;

      link.setAttribute('href', match.url);
      link.textContent = match.title;
    });
  };

  syncCollectionBreadcrumb();

  document.addEventListener('shopify:section:load', (event) => {
    syncCollectionBreadcrumb(event.target);
  });

  window.addEventListener('pageshow', () => {
    syncCollectionBreadcrumb();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var trigger = event.target && event.target.closest && event.target.closest('[data-acsb-custom-trigger]');

    if (!trigger) {
      return;
    }

    event.preventDefault();
  });

  } catch(e) { console.error(e); }
})();
})();
